module.exports = __webpack_public_path__ + "img/b56f2c46b0075ab0627997d8b79fb766.54ae9689.jpg";